import PageHero from "../components/sections/PageHero";
import { useState } from "react";
import ThankYou from "../components/sections/ThankYou";
import AlertBar from "../components/common/AlertBar";
import useAxios from "../hooks/useAxios";
import CustomerService from "assets/images/customer-service.svg";

const Contact = () => {
    const [inquiry, setInquiry] = useState({
        email: "",
        subject: "",
        message: "",
    });
    const axios = useAxios();
    const [isError, setIsError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const onEmailChange = (e) => {
        setInquiry((old) => ({ ...old, email: e.target.value }));
    };
    const onSubjectChange = (e) => {
        setInquiry((old) => ({ ...old, subject: e.target.value }));
    };
    const onMessageChange = (e) => {
        setInquiry((old) => ({ ...old, message: e.target.value }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowLoading(true);
        try {
            const response = await axios.post(
                "/contact.php",
                JSON.stringify(inquiry)
            );
            if (response.status === 200) {
                setShowSuccess(true);
            }
        } catch (error) {
            console.log("this is error", error);
            setIsError(true);
        } finally {
            setShowLoading(false);
        }
    };

    return (
        <>
            <PageHero
                title="Get in touch!"
                subtitle="Send us a message"
                body="For inquiries and more information, please don't hesitate to contact us. Our team is ready to assist you and ensure you have all the details you need."
                image={CustomerService}
            />
            {showSuccess ? (
                <ThankYou />
            ) : (
                <section id="contact-form">
                    <div className="container">
                        <div className="max-w-2xl mx-auto">
                            <div className="bg-white rounded-3xl border border-gray-100 shadow-card p-6 md:p-10">
                                <form
                                        action="#"
                                        className="space-y-6"
                                        onSubmit={handleSubmit}
                                    >
                                        {isError && (
                                            <AlertBar msg="Something went wrong. Please try again later" />
                                        )}
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="block mb-2 font-semibold text-sm"
                                            >
                                                Your email
                                            </label>
                                            <input
                                                type="email"
                                                id="email"
                                                className="form-input"
                                                placeholder="your@email.com"
                                                required
                                                onChange={onEmailChange}
                                            />
                                        </div>
                                        <div>
                                            <label
                                                htmlFor="subject"
                                                className="block mb-2 font-semibold text-sm"
                                            >
                                                Subject
                                            </label>
                                            <input
                                                type="text"
                                                id="subject"
                                                className="form-input"
                                                placeholder="Let us know how we can help you"
                                                required
                                                onChange={onSubjectChange}
                                            />
                                        </div>
                                        <div>
                                            <label
                                                htmlFor="message"
                                                className="block mb-2 font-semibold text-sm"
                                            >
                                                Your message
                                            </label>
                                            <textarea
                                                id="message"
                                                rows="6"
                                                className="form-input resize-none"
                                                placeholder="Leave a message..."
                                                onChange={onMessageChange}
                                            ></textarea>
                                        </div>
                                        {showLoading ? (
                                            <button
                                                type="button"
                                                className="btn-loading"
                                            >
                                                Sending...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn w-full sm:w-auto"
                                            >
                                                Send message
                                            </button>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
            )}
        </>
    );
};

export default Contact;
